import { render, staticRenderFns } from "./Blue.vue?vue&type=template&id=2abcdd45&scoped=true&"
import script from "./Blue.vue?vue&type=script&lang=js&"
export * from "./Blue.vue?vue&type=script&lang=js&"
import style0 from "./Blue.vue?vue&type=style&index=0&id=2abcdd45&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abcdd45",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsPublicTheExportNew: require('/web/components/objects/public/TheExportNew.vue').default,TheBlockHeader: require('/web/components/TheBlockHeader.vue').default})
